// We have two sets of filter states, prefetchedFilters and filters. Both essentially are copies of each other
// but they are used to store filter selections differently as explained below.

// The prefetchedFilters state stores the selected filter selections you make as you select/deselect any filter.
// The reason we have this state is to prevent any calls to the selections api when clicking on the close button
// on the FilterHeader.
// As when we click the close button we expect to retain what the selections we had previously displayed
// and no calls to the api to be made.
// When the close button is pressed then we reset the selections made to what is in the filters state so we
// don't store anything that we are not using to send to the api

// The filters state stores the finalised selections after clicking on Show X/All Selections on a Filter page and then
// makes the subsequent API call to selections to display the results. Anything filter selections stored in here will be
// used in the parameters we pass when making a call to the selections api.
// When the user clicks on the Clear All button this will clear all the selections in filters as well as in prefetchedFilters

export const initialState = {
  ppConfig: {},
  selectedFavourite: "",
  storedFavourites: [],
  prefetchedFilters: {
    stats: "last5",
    date: [],
    fixtures: {
      today: [],
      tomorrow: [],
    },
    markets: [],
    odds: {
      minOdds: null,
      maxOdds: null,
    },
    favourites: {
      markets: null,
      odds: null,
    },
    sortBy: "stats-desc",
  },
  filters: {
    stats: "last5",
    date: [],
    fixtures: {
      today: [],
      tomorrow: [],
    },
    markets: [],
    odds: {
      minOdds: null,
      maxOdds: null,
    },
    favourites: {
      markets: null,
      odds: null,
    },
    sortBy: "stats-desc",
  },
  onboardingStep: 0,
  prevOnboardingStep: 0,
  responseMessage: null,
};
